// src/components/TableMagazine.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteAdminNeighborhood } from '@/API/apiService';

export interface Magazine {
  id: number;
  date_time: string;
  title: string;
}

interface TableMagazineProps {
  magazines: Magazine[];
}

export const TableMagazine: React.FC<TableMagazineProps> = ({ magazines }) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const handleRowClick = (id: number) => {
    navigate(`/admin/magazine/shop/${id}`);
  };

  const handleEdit = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/admin/magazine/shop/${id}`);
  };

  // 削除ボタン押下時にモーダルを表示する
  const handleDeleteClick = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedId(id);
    setModalOpen(true);
  };

  // モーダルで「はい」を選択したときの処理
  const confirmDelete = async () => {
    if (selectedId !== null) {
      try {
        console.log(`Deleted RUN ${selectedId}`);
        await deleteAdminNeighborhood(selectedId);
        // 一覧更新のため画面再読み込み（必要に応じて state 更新など）
        window.location.reload();
      } catch (error) {
        console.error('Error deleting magazine:', error);
      } finally {
        setModalOpen(false);
        setSelectedId(null);
      }
    }
  };

  // モーダルで「いいえ」を選択したときの処理
  const cancelDelete = () => {
    setModalOpen(false);
    setSelectedId(null);
  };

  const handleNewCreate = () => {
    navigate(`/admin/magazine/shop/new`);
  };

  return (
    <>
      <div>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded">
            <thead className="min-w-full bg-white border-b-2 border-[#DDDDDD] rounded">
              <tr>
                <th className="p-3 text-left text-black text-sm">追加日</th>
                <th
                  className="p-3 text-left text-black text-sm"
                  style={{ width: '200px' }}
                >
                  店名
                </th>
                <th className="p-3 text-left text-black text-sm">操作</th>
              </tr>
            </thead>
            <tbody>
              {magazines.map((item) => (
                <tr
                  key={item.id}
                  className="border-b border-[#DDDDDD] cursor-pointer hover:bg-gray-100"
                  onClick={() => handleRowClick(item.id)}
                >
                  <td className="px-[16px] py-4 text-black text-sm">
                    {item.date_time}
                  </td>
                  <td
                    className="px-[16px] py-4 text-black text-sm"
                    style={{ width: '200px' }}
                  >
                    {item.title}
                  </td>
                  <td
                    className="px-[16px] py-4 text-black text-xs"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="flex space-x-2">
                      <button
                        className="text-black underline cursor-pointer text-xs"
                        onClick={(e) => handleEdit(item.id, e)}
                      >
                        編集
                      </button>
                      <button
                        className="text-red-500 underline cursor-pointer text-xs"
                        onClick={(e) => handleDeleteClick(item.id, e)}
                      >
                        削除
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* モーダルの実装 */}
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-md">
            <p className="text-lg">本当に削除しますか？</p>
            <div className="mt-4 flex justify-end space-x-4">
              <button
                onClick={confirmDelete}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                はい
              </button>
              <button
                onClick={cancelDelete}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                いいえ
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
